import BaseClass from "./BaseClass";

class DirectoryTexts extends BaseClass {
  static get schema() {
    return {
      type: {
        editable: true,
        props: { sortable: true }
      },
      code: {
        editable: true,
        props: { sortable: true }
      },
      created_at: {
        props: { sortable: true }
      },
      updated_at: {
        props: { sortable: true }
      }
    };
  }

  get actions() {
    return {
      edit: {
        handler: () => Promise.resolve("edit"),
        props: { type: "primary" },
        in_edit_mode: false
      },
      delete: {
        handler: () => this._handleDelete(),
        props: { type: "danger" },
        show: !!this.uuid,
        in_edit_mode: false
      },
      go_back: {
        handler: () => Promise.resolve("go_back"),
        props: { type: "default" },
        in_edit_mode: false
      },
      save: {
        handler: () => this._handleSave(),
        props: {
          type: "success",
          disabled: !(this.type && this.code && this.data)
        },
        in_edit_mode: true
      },
      cancel: {
        handler: () => this._handleCancel(),
        props: { type: "default" },
        in_edit_mode: true
      }
    };
  }

  get allowEditData() {
    return !!this.type && !!this.code;
  }

  beShownForFilter(filter) {
    return (
      !filter ||
      this.type.toLowerCase().includes(filter.toLowerCase()) ||
      this.code.toLowerCase().includes(filter.toLowerCase())
    );
  }

  getModelByUUID(uuid) {
    if (uuid === "new") {
      return Promise.resolve(this);
    }
    return this._api
      .query({
        query: require("../../graphql/texts/texts_single_model.graphql"),
        variables: { uuid: uuid }
      })
      .then(res => {
        Object.assign(this, res.data.directory_texts);
        return this;
      });
  }

  addNewDataField(field) {
    if (typeof this.data !== "object") {
      this.data = {};
    }
    if (typeof this.data[field] !== "undefined") {
      throw new Error("Imposible add new field. Field alredy exist in data");
    }
    this.data[field] = { ua: "", en: "", ru: "" };
  }

  _handleSave() {
    return this._api
      .mutate({
        mutation: require("../../graphql/texts/texts_save.graphql"),
        variables: this
      })
      .then(res => {
        Object.assign(this, res.data.directory_texts);
        return "save";
      });
  }

  _handleDelete() {
    return this._confirm("Are you sure want to delete this Text?")
      .then(() => {
        return this._api
          .mutate({
            mutation: require("../../graphql/texts/texts_save.graphql"),
            variables: Object.assign({ action: "delete" }, this)
          })
          .then(res => {
            return "delete";
          });
      })
      .catch(() => {
        return "scipped";
      });
  }

  _handleCancel() {
    if (typeof this.uuid === "undefined") {
      return Promise.resolve("cancel");
    } else {
      return this.getModelByUUID(this.uuid).then(() => {
        return "cancel";
      });
    }
  }
}

export default DirectoryTexts;
